var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-2rem text-left flex-row flex-ac"},[_c('div',{staticClass:"line"}),_c('p',{staticClass:"ml-10"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }